// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qu_a bhv_rq bhv_kr bhv_ks","PostDetailRight__brandDaysPosts":"qu_b bhv_rq bhv_kr bhv_ks"};